var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { Button } from "@gravity-ui/uikit";
import { ConfirmModal } from "@/components/modal/ConfirmModal";
import { TooltipWrap } from "@/components/TooltipWrap";
import { GameStatus, useCreateGameForCustomSlotMutation, useCreateGameForSlotMutation, useDeleteGameMutation, WorkTimeMode, } from "@/store/api";
import { dateTimeConvertToMinutes, timeConvertToFormattedString, } from "@/tools/dateTools";
import { InfoModal } from "./InfoModal";
import { WorktimeModal } from "./WorktimeModal";
/** Сетка фиксированных слотов на конкретные сутки */
export var GridSlots = function (props) {
    var _a;
    var _b = useCreateGameForSlotMutation(), createGameAction = _b[0], createGameState = _b[1];
    var _c = useDeleteGameMutation(), deleteGameAction = _c[0], deleteGameState = _c[1];
    var _d = useState([]), gridSlots = _d[0], setGridSlots = _d[1];
    // Состояние окна подтверждения брони
    var _e = useState(false), confirmOpen = _e[0], setConfirmOpen = _e[1];
    // Состояние окна подтверждения удаления брони
    var _f = useState(false), deleteBookingOpen = _f[0], setDeleteBookingOpen = _f[1];
    // Состояние окна показа данных слота
    var _g = useState(false), infoOpen = _g[0], setInfoOpen = _g[1];
    // Состояние окна показа данных кастомного слота
    var _h = useState(false), worktimeOpen = _h[0], setWorktimeOpen = _h[1];
    // Данные по слоту, для которго показано окно
    // используется и для подтверждения брони, и для показа данных
    var activeSlot = useRef(null);
    /** Закрытие окна подтверждения брони */
    var confirmCloseHandler = function () {
        activeSlot.current = null;
        setConfirmOpen(false);
    };
    /** Открытие окна подтверждения брони */
    var confirmOpenHandler = function () { return setConfirmOpen(true); };
    /** Бронирование слота */
    var slotBookingHandler = function (slot) {
        activeSlot.current = slot;
        confirmOpenHandler();
    };
    /** Закрытие окна показа данных слота */
    var infoCloseHandler = function () {
        activeSlot.current = null;
        setInfoOpen(false);
    };
    /** Открытие окна показа данных слота */
    var slotInfoHandler = function (slot) {
        activeSlot.current = slot;
        setInfoOpen(true);
    };
    var worktimeOpenHandler = function (timeSlot) {
        activeSlot.current = timeSlot;
        setWorktimeOpen(true);
    };
    var worktimeCloseHandler = function () {
        activeSlot.current = null;
        setWorktimeOpen(false);
    };
    /** Подтверждение бронирования слота из сетки */
    var confirmActionHandler = function () { return __awaiter(void 0, void 0, void 0, function () {
        var bookedSlot, err_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!activeSlot.current)
                        return [2 /*return*/];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, createGameAction({
                            date: props.day.date,
                            slotId: activeSlot.current.timeSlotId,
                            placeId: props.placeId,
                        })];
                case 2:
                    bookedSlot = _b.sent();
                    (_a = props.onSuccessBooking) === null || _a === void 0 ? void 0 : _a.call(props, bookedSlot.data.id);
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _b.sent();
                    console.error(err_1);
                    return [3 /*break*/, 5];
                case 4:
                    confirmCloseHandler();
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var createGameCustomAction = useCreateGameForCustomSlotMutation()[0];
    /** Подтверждение бронирования кастомного слота */
    var customConfirmActionHandler = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var customBookedSlot, err_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, 3, 4]);
                    return [4 /*yield*/, createGameCustomAction({
                            placeId: props.placeId,
                            createGameDto: {
                                date: props.day.date,
                                timeStart: dateTimeConvertToMinutes(data.start),
                                timeEnd: dateTimeConvertToMinutes(data.end),
                                status: GameStatus.Draft,
                            },
                        })];
                case 1:
                    customBookedSlot = _b.sent();
                    (_a = props.onSuccessBooking) === null || _a === void 0 ? void 0 : _a.call(props, customBookedSlot.data.id);
                    return [3 /*break*/, 4];
                case 2:
                    err_2 = _b.sent();
                    console.error(err_2);
                    return [3 /*break*/, 4];
                case 3:
                    worktimeCloseHandler();
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    /** Переход к игре по id слота */
    var clickAdvancedHandler = function () {
        var _a, _b;
        if (!((_a = activeSlot.current) === null || _a === void 0 ? void 0 : _a.gameId))
            return;
        (_b = props.onSuccessBooking) === null || _b === void 0 ? void 0 : _b.call(props, activeSlot.current.gameId);
    };
    /** Запуск подтверждения отмены брони */
    var deleteBookingHandler = function () {
        setInfoOpen(false);
        setDeleteBookingOpen(true);
    };
    /** Закрытие окна подтверждеия отмены брони */
    var deleteBookingCloseHandler = function () {
        activeSlot.current = null;
        setDeleteBookingOpen(false);
    };
    /** Подтверждение удаления брони в окне */
    var deleteGameActionHandler = function () { return __awaiter(void 0, void 0, void 0, function () {
        var canceledSlot, err_3;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!((_a = activeSlot.current) === null || _a === void 0 ? void 0 : _a.gameId))
                        return [2 /*return*/];
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, deleteGameAction({
                            id: activeSlot.current.gameId,
                        })];
                case 2:
                    canceledSlot = _c.sent();
                    (_b = props.onSuccessCancel) === null || _b === void 0 ? void 0 : _b.call(props, canceledSlot.data.id);
                    return [3 /*break*/, 5];
                case 3:
                    err_3 = _c.sent();
                    console.error(err_3);
                    return [3 /*break*/, 5];
                case 4:
                    deleteBookingCloseHandler();
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    // Заполняем слоты
    useEffect(function () {
        var result = [];
        // Добавляем слоты только с уникальными началами и концами
        // и без пересечений
        var addSlot = function (slot) {
            if (!result.some(function (r) { return r.timeStart === slot.timeStart && r.timeEnd === slot.timeEnd; }) &&
                result.every(function (r) { return slot.timeStart >= r.timeEnd; })) {
                result.push(slot);
            }
        };
        var _loop_1 = function (timeSlot) {
            // Находим занятые слоты, пересекающиеся с текущим свободным
            var crossedBooked = props.day.games.filter(function (game) {
                return game.timeStart < timeSlot.timeEnd && game.timeEnd > timeSlot.timeStart;
            });
            if (crossedBooked.length > 0) {
                // Добавляем все crossedBooked как новые слоты
                crossedBooked.forEach(function (game) {
                    var resultSlot = {
                        gameId: game.id,
                        timeSlotId: timeSlot.id,
                        timeStart: game.timeStart,
                        timeEnd: game.timeEnd,
                        date: game.date,
                    };
                    addSlot(resultSlot);
                });
            }
            else {
                addSlot({
                    timeSlotId: timeSlot.id,
                    timeStart: timeSlot.timeStart,
                    timeEnd: timeSlot.timeEnd,
                    date: props.day.date,
                });
            }
        };
        for (var _i = 0, _a = __spreadArray([], props.day.timeSlots, true).sort(function (a, b) { return a.timeStart - b.timeStart; }); _i < _a.length; _i++) {
            var timeSlot = _a[_i];
            _loop_1(timeSlot);
        }
        // Добавляем занятые слоты, которых нет в основном расписании
        props.day.games.forEach(function (game) {
            var resultSlot = {
                gameId: game.id,
                timeSlotId: game.id,
                timeStart: game.timeStart,
                timeEnd: game.timeEnd,
                date: game.date,
            };
            addSlot(resultSlot);
        });
        setGridSlots(result);
    }, [props.day]);
    var slotClickHandler = function (slot) {
        // Если обработчик клика задан снаружи, то игнорируем внутреннюю логику компонента
        if (props.onClick) {
            props.onClick(slot);
        }
        else if (slot.gameId) {
            slotInfoHandler(slot);
        }
        else if (props.day.workTimeMode === WorkTimeMode.Timegrid) {
            slotBookingHandler(slot);
        }
        else if (props.day.workTimeMode === WorkTimeMode.Custom) {
            worktimeOpenHandler(slot);
        }
    };
    var getSlotState = function (gameId, slotGameId) {
        var result = {
            tooltip: gameId && slotGameId && gameId !== slotGameId
                ? "Слот занят"
                : slotGameId
                    ? gameId
                        ? "Текущий выбор"
                        : "Слот занят"
                    : "Доступен для выбора",
            view: gameId && slotGameId && gameId !== slotGameId
                ? "outlined-utility"
                : slotGameId
                    ? gameId
                        ? "outlined-info"
                        : "outlined-utility"
                    : "outlined-success",
            selected: !!slotGameId || (gameId && slotGameId && gameId !== slotGameId),
        };
        return result;
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { style: { marginLeft: -8 }, children: [gridSlots.map(function (slot, slotIdx) {
                        var slotState = getSlotState(props.gameId, slot.gameId);
                        return (_jsx(TooltipWrap, { content: slotState.tooltip, placement: "top", children: _jsxs(Button, { style: { marginLeft: 8, marginTop: 8 }, onClick: function () { return slotClickHandler(slot); }, disabled: createGameState.isLoading || deleteGameState.isLoading, view: slotState.view, selected: slotState.selected, children: [timeConvertToFormattedString(slot.timeStart), " -", " ", timeConvertToFormattedString(slot.timeEnd)] }) }, "".concat(slot.timeStart, "_").concat(slotIdx)));
                    }), gridSlots.length === 0 && (_jsx(Button, { view: "flat", loading: true, style: { marginLeft: 8, marginTop: 8, visibility: "hidden" }, children: "\u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0430..." }))] }), _jsx(ConfirmModal, { open: confirmOpen, onClose: confirmCloseHandler, onConfirm: confirmActionHandler, children: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u0431\u0440\u043E\u043D\u044C" }), _jsx(InfoModal, { open: infoOpen, onClose: infoCloseHandler, slot: activeSlot.current, onDeleteBooking: deleteBookingHandler, onClickAdvanced: clickAdvancedHandler }), _jsx(ConfirmModal, { open: deleteBookingOpen, onClose: deleteBookingCloseHandler, onConfirm: deleteGameActionHandler, children: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0435" }), _jsx(WorktimeModal, { open: worktimeOpen, onClose: worktimeCloseHandler, onConfirm: customConfirmActionHandler, timeSlot: activeSlot.current, scheduleId: props.day.id }, (_a = activeSlot === null || activeSlot === void 0 ? void 0 : activeSlot.current) === null || _a === void 0 ? void 0 : _a.timeStart)] }));
};
